import request from '@/utils/request'

//获取我的最新实验课程成绩
export function getmyperformancelist(params) {
  return request({
    url: '/portal/course-lib-study/get-my-performance-list',
    method: 'GET',
    params
  })
}